// Минимальный роутер на History API.
//
// Экранов всего четыре (планировщик, админка, сброс пароля, подтверждение
// почты), и ради них не хочется тянуть react-router: SPA-фолбэк на сервере
// уже отдаёт index.html на любой путь, а остальное — тридцать строк.
import { useMemo, useSyncExternalStore } from 'react';

const listeners = new Set<() => void>();

function emit(): void {
  for (const listener of listeners) listener();
}

function subscribe(onChange: () => void): () => void {
  listeners.add(onChange);
  window.addEventListener('popstate', onChange);
  return () => {
    listeners.delete(onChange);
    window.removeEventListener('popstate', onChange);
  };
}

function getSnapshot(): string {
  return `${window.location.pathname}${window.location.search}`;
}

/** Снимок для серверного рендера/тестов без window. */
function getServerSnapshot(): string {
  return '/';
}

export function navigate(to: string, options: { replace?: boolean } = {}): void {
  if (getSnapshot() === to) return;
  if (options.replace) window.history.replaceState(null, '', to);
  else window.history.pushState(null, '', to);
  emit();
}

export interface Route {
  /** Путь без параметров, всегда со слэшем в начале. */
  path: string;
  query: URLSearchParams;
}

export function useRoute(): Route {
  const href = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return useMemo(() => {
    const [path, search = ''] = href.split('?');
    return { path: path || '/', query: new URLSearchParams(search) };
  }, [href]);
}
